import { CommonStore } from '../common-store';

const storeModule = new CommonStore(
  'camp/knowledge/sub-category',
  { name: 'camp.knowledge.sub-category.index' }
);

export default {
  namespaced: storeModule.namespaced,
  state: storeModule.state,
  getters: storeModule.getters,
  actions: storeModule.actions,
  mutations: storeModule.mutations
};
